var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotSure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "message-question"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.6667 18.4297H13.6667L9.21674 21.3897C8.55674 21.8297 7.66675 21.3598 7.66675 20.5598V18.4297C4.66675 18.4297 2.66675 16.4297 2.66675 13.4297V7.42969C2.66675 4.42969 4.66675 2.42969 7.66675 2.42969H17.6667C20.6667 2.42969 22.6667 4.42969 22.6667 7.42969V13.4297C22.6667 16.4297 20.6667 18.4297 17.6667 18.4297Z",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.6668 11.3604V11.1504C12.6668 10.4704 13.0868 10.1104 13.5068 9.82037C13.9168 9.54037 14.3268 9.18039 14.3268 8.52039C14.3268 7.60039 13.5868 6.86035 12.6668 6.86035C11.7468 6.86035 11.0068 7.60039 11.0068 8.52039",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.6622 13.75H12.6712",
    stroke: "#6C727F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSure);
export default __webpack_public_path__ + "static/media/NotSure.32b7b0145b084dc256c59281af8c1276.svg";
export { ForwardRef as ReactComponent };